import React, { useState } from 'react';
import AutoComplete from 'react-google-autocomplete';
import { useTranslation } from 'react-i18next';
import { Flex } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import collect from 'collect.js';

export default function GooglePlacesSearch({ value, placeholder, options, onChange, onPlaceSelected }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Form:Address:GooglePlacesSearch' });

  const [types, setTypes] = useState(options?.types ?? []);

  const resetPlaceTypes = () => setTypes([]);

  return (
    <Flex vertical gap="4px">
      <Flex className="items-center w-full px-md py-xs border rounded-md transition-colors focus-within:border-brand-primary">
        <BankOutlined className="mr-md my-auto" />
        <AutoComplete
          apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
          onPlaceSelected={onPlaceSelected}
          onChange={onChange}
          value={value}
          placeholder={placeholder ?? t('placeholder')}
          className="w-full overflow-ellipsis border-none outline-none"
          options={{
            ...(options ?? {}),
            types,
          }}
          key={collect(types).implode('-')}
        />
      </Flex>
      <span className="pt-2xs">
        {t('labels.cant_find_place')}{' '}
        <span onClick={resetPlaceTypes} className="text-brand-primary hover:underline cursor-pointer">
          {t('labels.reset_categories')}
        </span>
      </span>
    </Flex>
  );
}
